import { h, render, Component } from 'preact'

import { defaultSortDirection } from '../lib/utilities'

export default class SortableColumnHeader extends Component {
  render(props, state) {
    const width = props.column === 'name' ? '20%' : 'auto';

    let newSortDirection = defaultSortDirection(props.column)
    
    if ( props.sort === props.column ) {
      newSortDirection = props.direction === 'asc' ? 'desc' : 'asc'
    }

    let sortIcon = ''
    let title = props.title
    
    if ( props.sort === props.column ) {
      if ( props.direction === 'asc' ) {
        sortIcon = <i class="ss-icon">&#x2B06;</i>
      } else {
        sortIcon = <i class="ss-icon">&#x2B07;</i>        
      }
      
      title = `Click to sort in ${ newSortDirection }ending direction`
    }
    
    const sortUrl = `#sort`
    
    return (
      <th width={ width }><a title={ title } 
                             onClick={ props.onClick }
                             data-sort={ props.column }
                             data-direction={ newSortDirection }
                             href={ sortUrl }>{ sortIcon }{ props.displayName }</a></th>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/sortable-column-header-component.js